function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.879,248.242c-4.278,0-7.758,3.48-7.758,7.758c0,4.278,3.48,7.758,7.758,7.758 c4.278,0,7.758-3.48,7.758-7.758C139.636,251.722,136.156,248.242,131.879,248.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.879,217.212c-21.388,0-38.788,17.4-38.788,38.788s17.4,38.788,38.788,38.788 s38.788-17.4,38.788-38.788S153.266,217.212,131.879,217.212z M131.879,271.515c-8.569,0-15.515-6.946-15.515-15.515 c0-8.569,6.946-15.515,15.515-15.515c8.567,0,15.515,6.946,15.515,15.515C147.394,264.569,140.446,271.515,131.879,271.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.879,240.485c-8.569,0-15.515,6.946-15.515,15.515c0,8.569,6.946,15.515,15.515,15.515 c8.567,0,15.515-6.946,15.515-15.515C147.394,247.431,140.446,240.485,131.879,240.485z M131.879,263.758 c-4.278,0-7.758-3.48-7.758-7.758c0-4.278,3.48-7.758,7.758-7.758c4.278,0,7.758,3.48,7.758,7.758 C139.636,260.278,136.156,263.758,131.879,263.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,248.242c-4.278,0-7.758,3.48-7.758,7.758c0,4.278,3.48,7.758,7.758,7.758 c4.278,0,7.758-3.48,7.758-7.758C263.758,251.722,260.278,248.242,256,248.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,217.212c-21.388,0-38.788,17.4-38.788,38.788s17.4,38.788,38.788,38.788 s38.788-17.4,38.788-38.788S277.388,217.212,256,217.212z M256,271.515c-8.569,0-15.515-6.946-15.515-15.515 c0-8.569,6.946-15.515,15.515-15.515c8.569,0,15.515,6.946,15.515,15.515C271.515,264.569,264.569,271.515,256,271.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,240.485c-8.569,0-15.515,6.946-15.515,15.515c0,8.569,6.946,15.515,15.515,15.515 c8.569,0,15.515-6.946,15.515-15.515C271.515,247.431,264.569,240.485,256,240.485z M256,263.758c-4.278,0-7.758-3.48-7.758-7.758 c0-4.278,3.48-7.758,7.758-7.758c4.278,0,7.758,3.48,7.758,7.758C263.758,260.278,260.278,263.758,256,263.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M372.364,256c0,4.278,3.48,7.758,7.758,7.758c4.278,0,7.758-3.48,7.758-7.758 c0-4.278-3.48-7.758-7.758-7.758C375.844,248.242,372.364,251.722,372.364,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.333,256c0,21.388,17.4,38.788,38.788,38.788c21.388,0,38.788-17.4,38.788-38.788 s-17.4-38.788-38.788-38.788C358.734,217.212,341.333,234.612,341.333,256z M395.636,256c0,8.569-6.946,15.515-15.515,15.515 c-8.569,0-15.515-6.946-15.515-15.515c0-8.569,6.946-15.515,15.515-15.515C388.69,240.485,395.636,247.431,395.636,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.606,256c0,8.569,6.946,15.515,15.515,15.515c8.569,0,15.515-6.946,15.515-15.515 c0-8.569-6.946-15.515-15.515-15.515C371.552,240.485,364.606,247.431,364.606,256z M387.879,256c0,4.278-3.48,7.758-7.758,7.758 c-4.278,0-7.758-3.48-7.758-7.758c0-4.278,3.48-7.758,7.758-7.758C384.399,248.242,387.879,251.722,387.879,256z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#719DF7"
    },
    d: "M256,0v217.212c21.388,0,38.788,17.4,38.788,38.788s-17.4,38.788-38.788,38.788V512 c141.158,0,256-114.842,256-256S397.158,0,256,0z M380.121,294.788c-21.388,0-38.788-17.4-38.788-38.788s17.4-38.788,38.788-38.788 c21.388,0,38.788,17.4,38.788,38.788S401.509,294.788,380.121,294.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6DEB"
    },
    d: "M217.212,256c0-21.388,17.4-38.788,38.788-38.788V0C114.842,0,0,114.842,0,256s114.842,256,256,256 V294.788C234.612,294.788,217.212,277.388,217.212,256z M131.879,294.788c-21.388,0-38.788-17.4-38.788-38.788 s17.4-38.788,38.788-38.788s38.788,17.4,38.788,38.788S153.266,294.788,131.879,294.788z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.a8045bdf5a533d837f5294a1caef45cd.svg";
export { ForwardRef as ReactComponent };